/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaVectorDistributionColours model module.
 * @module model/AqaVectorDistributionColours
 * @version v0
 */
export default class AqaVectorDistributionColours {
  /**
   * Constructs a new <code>AqaVectorDistributionColours</code>.
   * @alias module:model/AqaVectorDistributionColours
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaVectorDistributionColours</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaVectorDistributionColours} obj Optional instance to populate.
   * @return {module:model/AqaVectorDistributionColours} The populated <code>AqaVectorDistributionColours</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaVectorDistributionColours();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('orientation'))
        obj.orientation = ApiClient.convertToType(data['orientation'], 'String');
      if (data.hasOwnProperty('vectorId'))
        obj.vectorId = ApiClient.convertToType(data['vectorId'], 'Number');
      if (data.hasOwnProperty('valueRagBytes'))
        obj.valueRagBytes = ApiClient.convertToType(data['valueRagBytes'], {'String': {'String': 'Blob'}});
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaVectorDistributionColours.prototype.id = undefined;

/**
 * @member {String} snapshotId
 */
AqaVectorDistributionColours.prototype.snapshotId = undefined;

/**
 * Allowed values for the <code>orientation</code> property.
 * @enum {String}
 * @readonly
 */
AqaVectorDistributionColours.OrientationEnum = {
  /**
   * value: "column"
   * @const
   */
  column: "column",

  /**
   * value: "row"
   * @const
   */
  row: "row"
};
/**
 * @member {module:model/AqaVectorDistributionColours.OrientationEnum} orientation
 */
AqaVectorDistributionColours.prototype.orientation = undefined;

/**
 * @member {Number} vectorId
 */
AqaVectorDistributionColours.prototype.vectorId = undefined;

/**
 * @member {Object.<String, Object.<String, Blob>>} valueRagBytes
 */
AqaVectorDistributionColours.prototype.valueRagBytes = undefined;

